<div class="action-panel sopcard-panel">
  <div class="sopcard-header" (click)="accordionAction()">
    <i class="fa fa-rocket" style="margin-right:6px;"></i>
    <span class="sopcard-title">Project information</span>
    <i class="fa sopcard-chevron" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <div *ngIf="opened" class="action-panel-body">

    <!-- ── Project basics ─────────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title">Project</h6>
    <div class="row">
      <div class="col-md-6">
        <div class="detail-field"><label>Grant Agreement Number</label><p>{{ project.grant_agreement || '—' }}</p></div>
        <div class="detail-field"><label>Full project name</label><p>{{ project.full_project_name || '—' }}</p></div>
        <div class="detail-field"><label>Call Topic ID</label><p>{{ project.project_call_topic_id || '—' }}</p></div>
        <div class="detail-field"><label>Project officer name</label><p>{{ project.project_officer_name || '—' }}</p></div>
      </div>
      <div class="col-md-6">
        <div class="detail-field"><label>Project acronym</label><p>{{ project.project_acronym || '—' }}</p></div>
        <div class="detail-field"><label>Funding programme</label><p>{{ project.funding_programme || '—' }}</p></div>
        <div class="detail-field" *ngIf="project.other_funding_programme"><label>Other funding programme</label><p>{{ project.other_funding_programme }}</p></div>
        <div class="detail-field" *ngIf="project.funding_programme_detail"><label>Funding programme detail</label><p>{{ project.funding_programme_detail }}</p></div>
        <div class="detail-field"><label>Project Website</label>
          <p>
            <a *ngIf="project.project_website" [href]="project.project_website" target="_blank" rel="noopener">{{ project.project_website }}</a>
            <span *ngIf="!project.project_website">—</span>
          </p>
        </div>
        <div class="detail-field"><label>Submission (UTC)</label><p>{{ timestampToDate(project.created_at) }}</p></div>
      </div>
    </div>

    <!-- ── Topics ─────────────────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title">Topics</h6>
    <ul class="topic-tree" *ngFor="let topic of getTopicTags()">
      <li class="topic-l1">
        <span class="topic-name-l1">{{ topic }}</span>
        <ul *ngFor="let tag of getTopicTags(topic)">
          <li class="topic-l2">
            <span class="topic-name-l2">{{ tag }}</span>
            <ul *ngFor="let t of getTopicTags(topic, tag)">
              <li class="topic-l3">{{ t }}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    <!-- ── Support requested ──────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title">Support the project requires</h6>
    <div class="detail-field">
      <label>Information / activity to attain</label>
      <ul class="list-unstyled" *ngIf="project.information_to_attain?.length">
        <li *ngFor="let item of project.information_to_attain">
          <i class="fa fa-check" style="color:#1f8a3a; margin-right:6px;"></i>{{ item }}
        </li>
      </ul>
      <p *ngIf="!project.information_to_attain?.length" class="text-muted">—</p>
    </div>
    <div class="detail-field">
      <label>Short project description</label>
      <div [innerHTML]="project.project_short_description || '—'"></div>
    </div>
    <div class="detail-field">
      <label>Standardisation objectives</label>
      <div [innerHTML]="project.objectives_standardisation || '—'"></div>
    </div>
    <div class="detail-field">
      <label>Why apply for HSBooster service</label>
      <div [innerHTML]="project.why_the_project_applying || '—'"></div>
    </div>
    <div *ngIf="project.version == 'v1'" class="detail-field">
      <label>Target TC/SC/WG</label>
      <div [innerHTML]="project.which_group_contribute_to || '—'"></div>
    </div>

    <!-- ── Standards targeted (v2) ────────────────────────────────────────── -->
    <ng-container *ngIf="project.version == 'v2' && project.standard_reference?.length">
      <h6 class="sopcard-section-title">Standards targeted</h6>
      <div *ngFor="let std of project.standard_reference; let i = index" class="sopcard-subsection">
        <div class="sopcard-subsection-title">Standard {{ i + 1 }}</div>
        <div class="row">
          <div class="col-md-6">
            <div class="detail-field"><label>SDO / NSB / NC</label><p>{{ std.represent || '—' }}</p></div>
            <div class="detail-field"><label>Number of TC/SC/WG</label><p>{{ std.number_sdo || '—' }}</p></div>
            <div class="detail-field"><label>Contribute to this standard</label>
              <p>
                <i *ngIf="std.is_contribute == '1'" class="fa fa-check" style="color:#1f8a3a;"></i>
                <i *ngIf="std.is_contribute == '0'" class="fa fa-times" style="color:#c0392b;"></i>
                <span *ngIf="std.is_contribute != '1' && std.is_contribute != '0'">—</span>
              </p>
            </div>
            <div class="detail-field" *ngIf="std.other_options"><label>Other options</label><p>{{ std.other_options }}</p></div>
          </div>
          <div class="col-md-6">
            <div class="detail-field"><label>Title of TC/SC/WG</label><p>{{ std.title_sdo || '—' }}</p></div>
            <div class="detail-field"><label>Use this standard in project</label>
              <p>
                <i *ngIf="std.is_use == '1'" class="fa fa-check" style="color:#1f8a3a;"></i>
                <i *ngIf="std.is_use == '0'" class="fa fa-times" style="color:#c0392b;"></i>
                <span *ngIf="std.is_use != '1' && std.is_use != '0'">—</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ── Attachments ────────────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title">Related attachments</h6>
    <div *ngFor="let document of project.related_doc_application" class="file-row">
      <i class="fa fa-download"></i>
      <a [href]="document.url" target="_blank" rel="noopener">{{ document.description }}</a>
    </div>
    <p *ngIf="!project.related_doc_application?.length" class="text-muted" style="margin:0;">—</p>

    <!-- ── Representative ─────────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title">Project representative</h6>
    <div class="row">
      <div class="col-md-6">
        <div class="detail-field"><label>Name</label><p><span *ngIf="project.version == 'v2'">{{ project.title }} </span>{{ project.name }} {{ project.surname }}</p></div>
        <div class="detail-field"><label>Organisation</label><p>{{ project.organisation || '—' }}</p></div>
        <div class="detail-field"><label>Organisation type</label><p>{{ project.organisation_type || '—' }}</p></div>
        <div class="detail-field"><label>Phone</label><p>{{ project.phone_number || '—' }}</p></div>
      </div>
      <div class="col-md-6">
        <div class="detail-field"><label>Email</label><p>{{ project.email || '—' }}</p></div>
        <div class="detail-field"><label>Country</label><p>{{ project.country || '—' }}</p></div>
        <div class="detail-field"><label>Gender</label><p>{{ project.gender || '—' }}</p></div>
      </div>
    </div>

  </div>
</div>
